const firebaseConfig = {
  apiKey: "AIzaSyCnnR_7khJ-RSbO9hO4bzyee1cmERPmW3Y",
  authDomain: "lti-jam-collahuasi.firebaseapp.com",
  projectId: "lti-jam-collahuasi",
  storageBucket: "lti-jam-collahuasi.appspot.com",
  messagingSenderId: "588191832281",
  appId: "1:588191832281:web:682729547abff6646486c8"
};

export default firebaseConfig;